import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6746dfcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment" }
const _hoisted_2 = { class: "payment__buy-group" }
const _hoisted_3 = { class: "payment__sum" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "payment__sum--header" }, "Total price: ", -1 /* HOISTED */))
const _hoisted_5 = { class: "payment__sum--total" }

import { LocalStorageApi } from '@/services/local-storage';
import ModalPayCard from '@/components/modal/ModalPayCard.vue';
import { useCart, useModal, usePagination, usePromo } from '@/store';
import { storeToRefs } from 'pinia';
import { LSKey } from '@/store/cart/_constants';
import { RouteNames } from '@/router/names';

import router from '@/router';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalPayment',
  setup(__props) {

const _LS = LocalStorageApi.getInstance();
const modalStore = useModal();
const paginationStore = usePagination();
const promoStore = usePromo();
const cartStore = useCart();
const { getPromoPrice } = storeToRefs(promoStore);
const { modalIsShow, isAllValid, orderIsCompleted, buyAttemt } = storeToRefs(modalStore);

const closeModal = (): void => {
  modalStore.$reset();
  modalIsShow.value = false;
  buyAttemt.value = false;
};

const buy = (): void => {
  if (isAllValid.value) {
    orderIsCompleted.value = true;
    _LS.removeProperties([LSKey.cart, LSKey.page, LSKey.limit]);
    cartStore.clearCart();
    cartStore.$reset();
    paginationStore.$reset();
    promoStore.$reset();
    buyAttemt.value = false;

    setTimeout((): void => {
      orderIsCompleted.value = false;
      closeModal();
      router.push({ name: RouteNames.landing });
    }, 3000);
    return;
  }

  buyAttemt.value = true;
};

return (_ctx: any,_cache: any) => {
  const _component_AppNumber = _resolveComponent("AppNumber")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ModalPayCard, { class: "payment__card" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, [
          _createTextVNode(" $"),
          _createVNode(_component_AppNumber, {
            input: _unref(getPromoPrice),
            fixed: 2
          }, null, 8 /* PROPS */, ["input"])
        ])
      ]),
      _createVNode(_component_AppButton, {
        class: "payment__buy-group--button",
        onClick: buy
      }, {
        default: _withCtx(() => [
          _createTextVNode("Confirm")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("span", {
        class: _normalizeClass(["payment__buy-group--alert", { visible: _unref(buyAttemt) }])
      }, " Please make sure all fields are filled in correctly ", 2 /* CLASS */)
    ])
  ]))
}
}

})